import { Card } from "@/components/ui/card";
import { Callout } from "./callout";

export const FacialRecognitionCard = () => {
  return (
    <Card className="px-8">
      <div className="flex flex-wrap justify-between md:flex-nowrap">
        <div className="relative max-w-lg">
          <Callout>Interface</Callout>
          <p className="my-4 text-2xl">Facial Recognition</p>
          <div className="space-y-6 font-serif max-sm:text-lg/8">
            <p>
              The system supports multi-face recognition, enabling fast and accurate verification of
              an entire group at once. This is ideal for offices, secure zones, educational
              institutions, or events where large numbers of people need to be verified quickly.
            </p>
            <p>
              Once a face is verified, the system confirms the match in real-time, indicating
              whether the individual is cleared for access. This ensures that only pre-verified
              individuals gain entry, improving both security and operational efficiency.
            </p>
          </div>
        </div>
        <div className="relative">
          <div className="not-sr-only mix-blend-multiply dark:mix-blend-exclusion dark:hue-rotate-180 dark:invert">
            <img alt="Flash Face" src="/static/face-faded.png" />
          </div>
          <div className="absolute inset-0 bg-radial from-transparent to-card to-75%" />
        </div>
      </div>
    </Card>
  );
};
